import { useGetAgroOverviewTableQuery } from 'services/api/Meteorology/Agro/Overview';
import useOverviewErrorState from './useOverviewErrorState';

/**
 * Tabela de localidades monitoradas. Primeiro acesso do dia pode levar ~28 s
 * (cache MISS da fonte) — o spinner fica em isFetching, SEM timeout próprio
 * (contrato agro-overview.md, §6 obs. 7).
 */
export default function useOverviewLocations() {
  const {
    data, error, isFetching, refetch,
  } = useGetAgroOverviewTableQuery();
  const errorKind = useOverviewErrorState(error, isFetching);

  return {
    locations: data?.localidades,
    total: data?.total,
    isFetching,
    errorKind,
    retry: refetch,
  };
}
